<script setup lang="ts">
import type { Customer } from '@/types/customer';

interface Props {
  recentCustomers: Customer[];
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'select-customer': [customer: Customer];
}>();

const selectCustomer = (customer: Customer) => {
  emit('select-customer', customer);
};
</script>

<template>
  <div
    v-if="recentCustomers && recentCustomers.length > 0"
    class="mt-6"
  >
    <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
      Clientes Recientes
    </h3>
    <div class="space-y-2">
      <div
        v-for="customer in recentCustomers.slice(0, 5)"
        :key="customer.id"
        class="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors"
        @click="selectCustomer(customer)"
      >
        <div class="flex justify-between items-center">
          <div>
            <h4 class="font-medium text-gray-900 dark:text-gray-100">
              {{ customer.name }}
            </h4>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              {{ customer.phone }}
            </p>
          </div>
          <span class="text-xs text-gray-500 dark:text-gray-400">{{ customer.order_count }} pedidos</span>
        </div>
      </div>
    </div>
  </div>
</template>
